import { Stack } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import SelectedTripSellingPointItem from './SelectedTripSellingPointItem';

const SelectedTripBannerUSP = () => {
  const { t } = useTranslation();

  return (
    <Stack as="ul" data-testid="selected-trip-banner-usp">
      <SelectedTripSellingPointItem label={t('YourSelectedTrip.USPOne.Label')} />
      <SelectedTripSellingPointItem label={t('YourSelectedTrip.USPTwo.Label')} />
      <SelectedTripSellingPointItem label={t('YourSelectedTrip.USPThree.Label')} />
    </Stack>
  );
};

export default SelectedTripBannerUSP;
